import FileDialog from './FileDialog';
import NoteDialog from './NoteDialog';
import PhotoDialog from './PhotoDialog';
import TaskDialog from './TaskDialog';

export {
  FileDialog,
  NoteDialog,
  PhotoDialog,
  TaskDialog,
}



// WEBPACK FOOTER //
// ./src/components/admin/Jobs/Dialog/index.js